import { Text } from "@/elements"
import { FragmentType, useFragment } from "@/gql"
import { ClosedJobPostingFragmentDoc } from "@/gql/graphql"
import { format, formatDistanceToNow, isWithinInterval, subDays } from "date-fns"
import { JobTitleColorised } from "@/components/JobTitleColorised"
import { ClosedJobMenu } from "./CloseJobMenu"
import adjustDateForTimezone from "@/utils/dates"

const TableRowCell = ({ text }: { text: string | null | undefined }) => {
  return (
    <td className={`whitespace-break-spaces px-4 text-left`}>
      <div className="flex items-center">
        <Text variant="label" className="text-fg-2">
          {text}
        </Text>
      </div>
    </td>
  )
}

interface Props {
  data: FragmentType<typeof ClosedJobPostingFragmentDoc> | null | undefined
}

const TableRow: React.FC<Props> = props => {
  const now = adjustDateForTimezone(new Date().toISOString())!
  const item = useFragment(ClosedJobPostingFragmentDoc, props.data)
  if (!item) return null
  return (
    <tr key={item.id} className={`h-[54px] border-b border-bg-3 hover:bg-bg-2 hover:bg-opacity-40`}>
      <td className="whitespace-break-spaces px-4 text-left">
        <div className="flex items-center">
          <JobTitleColorised
            jobPost={item}
            textVariant="label"
            maxLines={2}
            focusWordColor="text-fg-2"
            commonWordColor="text-fg-2"
          />
        </div>
      </td>
      {/*  <TableRowCell text="+ Add hire?" /> */}

      <TableRowCell
        text={
          isWithinInterval(item.createdAt, { start: subDays(now, 7), end: now })
            ? formatDistanceToNow(item.createdAt, { addSuffix: true })
            : format(item.createdAt, "MMM d, yyyy")
        }
      />
      <TableRowCell text={item.payString} />
      <TableRowCell text={item.applicationCount?.toString() ?? "0"} />
      <td className="h-[53px] whitespace-nowrap px-6 text-left">
        <ClosedJobMenu jobId={item.id} typename={item.__typename!} />
      </td>
    </tr>
  )
}

export default TableRow
